import { render, staticRenderFns } from "./AFCViewer.vue?vue&type=template&id=567e23cc&scoped=true"
import script from "./AFCViewer.vue?vue&type=script&lang=js"
export * from "./AFCViewer.vue?vue&type=script&lang=js"
import style0 from "./AFCViewer.vue?vue&type=style&index=0&id=567e23cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567e23cc",
  null
  
)

export default component.exports